module.exports = {"headerTitle":"Import subjects","headerTitleResults":"Result of subject import","close":"Cancel","ok":"OK"}